import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ChartSkeleton = ({height = 300}) => {
  return (
    <div style={{width: '100%', height: height}}>
      <Skeleton height={height}/>
    </div>
  );
};

export default ChartSkeleton;
